import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { defaultAxiosInstance } from "services/client"

import {
  GetAllPolicyPropertiesData,
  GetAllPoliciesData,
  ResponseData,
  ApiStatus,
} from "./common"

export const defaultUrl = `${
  process.env.REACT_APP_BASE_API_URL || ""
}/templates/cancellation-policy`

// ==========Get all policy properties by pmc id========
export interface GetAllPolicyPropertiesRequestData {
  pmcId: string
  templateId: string
  pageNo: number
  noOfRecords: number
  keyword: string
  sortDirection: string
  sortBy: string
  seasonal: boolean
}

export interface GetAllPolicyPropertiesRequest
  extends Partial<AxiosRequestConfig> {
  params: GetAllPolicyPropertiesRequestData
}

export interface GetAllPolicyPropertiesResponseData extends ResponseData {
  data: GetAllPolicyPropertiesData
}

export interface GetAllPolicyPropertiesResponse extends AxiosResponse {
  data: GetAllPolicyPropertiesResponseData
}

export function getAllPolicyProperties(
  {
    params,
    method = "post",
    url = `${defaultUrl}/properties/by-pmcId`,
    ...config
  }: GetAllPolicyPropertiesRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetAllPolicyPropertiesResponse> {
  return axiosInstance({
    data: params,
    method,
    url,
    ...config,
  }) as Promise<GetAllPolicyPropertiesResponse>
}

// ==============Get all policies==============
export interface GetAllPoliciesRequest extends Partial<AxiosRequestConfig> {
  params: {
    pmcId: string
  }
}

export interface GetAllPoliciesResponseData extends ResponseData {
  data: GetAllPoliciesData
}

export interface GetAllPoliciesResponse extends AxiosResponse {
  data: GetAllPoliciesResponseData
}

export function getAllPolicies(
  {
    params,
    method = "get",
    url = `${defaultUrl}/all`,
    ...config
  }: GetAllPoliciesRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetAllPoliciesResponse> {
  return axiosInstance({
    params,
    method,
    url,
    ...config,
  }) as Promise<GetAllPoliciesResponse>
}

// ===========Apply policy to property API===========
export interface GetApplyPolicyToPropertiesRequestData {
  templateId: string
  pmcId: string
  isAllUpdate: boolean
  propertyIds: string[]
  applySeasonal?: boolean
  seasonalPolicyList?: {
    id: string
    name: string
    effectiveFrom: string
    effectiveTo: string
  }[]
}

export interface GetApplyPolicyToPropertiesRequest
  extends Partial<AxiosRequestConfig> {
  params: {
    defaultPolicyForPmc: boolean
  }
  data: GetApplyPolicyToPropertiesRequestData
}

export interface GetApplyPolicyToPropertiesResponseData extends ResponseData {
  apiStatus: ApiStatus
  message: string
}

export interface GetApplyPolicyToPropertiesResponse extends AxiosResponse {
  data: GetApplyPolicyToPropertiesResponseData
}

export function getApplyPolicyToProperties(
  {
    params,
    data,
    method = "put",
    url = `${defaultUrl}/property/by-templateId`,
    ...config
  }: GetApplyPolicyToPropertiesRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<GetApplyPolicyToPropertiesResponse> {
  return axiosInstance({
    params,
    data,
    method,
    url,
    ...config,
  }) as Promise<GetApplyPolicyToPropertiesResponse>
}

// =============== Delete seasonal policy ==============
export interface DeleteSeasonalPolicyRequestData {
  pmcId: string
  propertyIds: string[]
  isAllUpdate: boolean
}

export interface DeleteSeasonalPolicyRequest
  extends Partial<AxiosRequestConfig> {
  params: DeleteSeasonalPolicyRequestData
}

export interface DeleteSeasonalPolicyResponseData extends ResponseData {
  apiStatus: ApiStatus
  message: string
}

export interface DeleteSeasonalPolicyResponse extends AxiosResponse {
  data: DeleteSeasonalPolicyResponseData
}

export function deleteSeasonalPolicy(
  {
    params,
    method = "post",
    url = `${defaultUrl}/seasonal-policy/delete`,
    ...config
  }: DeleteSeasonalPolicyRequest,
  axiosInstance: AxiosInstance = defaultAxiosInstance,
): Promise<DeleteSeasonalPolicyResponse> {
  return axiosInstance({
    data: params,
    method,
    url,
    ...config,
  }) as Promise<DeleteSeasonalPolicyResponse>
}
